// @ts-nocheck
import { Particle } from "../../entities";
import { TAU, clamp, rand, rgba } from "../../util";
import { Game } from "../game-base";

const VG_MAX_HITS = 3;
const VG_MELT_DUR = 1.35;

Game.prototype.voidglassCrackLevel = function (hits) {
  return clamp((hits || 0) / VG_MAX_HITS, 0, 1);
};

Game.prototype.voidglassCrackLines = function (fp, capH, r, seed, hits, crack) {
  const c = this.ctx;
  const jit = (i) => this.iceWallHash(i, seed);
  const nCracks = Math.max(2, (hits || 0) * 3 + 1);
  c.lineCap = "round";
  c.lineJoin = "round";
  for (let ci = 0; ci < nCracks; ci++) {
    const vi = Math.floor(jit(ci + 90) * fp.length);
    const p = fp[vi];
    let x = p.x * (0.28 + 0.52 * jit(ci + 91));
    let y = p.y - capH[vi] * (0.38 + 0.42 * jit(ci + 92));
    let dir = jit(ci + 93) * TAU;
    c.beginPath();
    c.moveTo(x, y);
    const segs = 2 + Math.floor(jit(ci + 94) * (2 + hits * 2));
    const reach = r * (0.08 + 0.14 * crack) * (0.55 + crack * 0.95);
    for (let s = 0; s < segs; s++) {
      dir += (jit(ci + s + 95) - 0.5) * (1.1 + crack * 0.8);
      x += Math.cos(dir) * reach * (0.65 + jit(ci + s + 96) * 0.7);
      y += Math.sin(dir) * reach * (0.65 + jit(ci + s + 96) * 0.7);
      c.lineTo(x, y);
    }
    c.strokeStyle = rgba("#061018", 0.35 + crack * 0.55);
    c.lineWidth = 1.2 + crack * 2.4;
    c.stroke();
    c.strokeStyle = rgba("#ffb060", 0.22 + crack * 0.58);
    c.lineWidth = 0.65 + crack * 1.1;
    c.stroke();
    c.strokeStyle = rgba("#e8fbff", 0.12 + crack * 0.38);
    c.lineWidth = 0.45;
    c.stroke();
  }
};

Game.prototype.drawVoidglassCrumblePieces = function (v, r, meltProg, alpha, seed) {
  const c = this.ctx;
  const jit = (i) => this.iceWallHash(i, seed);
  const n = 8;
  for (let i = 0; i < n; i++) {
    const a = (i / n) * TAU + jit(i + 10) * 0.55;
    const spread = r * (0.12 + meltProg * (0.62 + jit(i + 11) * 0.38));
    const cx = Math.cos(a) * spread;
    const cy = Math.sin(a) * spread * 0.42 + meltProg * r * 0.28;
    const cr = r * (0.18 + jit(i + 12) * 0.16) * (1 - meltProg * 0.45);
    const lean = (jit(i + 13) - 0.5) * 0.22 * meltProg;
    const collp = {
      crack: 0.85,
      fall: meltProg * 0.75,
      alpha: alpha * (1 - meltProg * 0.35),
      lean,
    };
    if (collp.alpha <= 0.03) continue;
    this.drawIceBoulder(cx, cy, cr, seed + i * 19.3, "#9fd4f0", collp);
  }
};

// Faceted 3D boulder — cracks deepen each hit; at 3 hits it crumbles into ground pieces.
Game.prototype.drawVoidglassBall = function (v) {
  const c = this.ctx;
  const r = v.r || 34;
  const hits = v.h || 0;
  const melt = v.ph === 2;
  const meltProg = melt ? 1 - clamp((v.life || 0) / VG_MELT_DUR, 0, 1) : 0;
  const alpha = melt ? 1 - meltProg * 0.85 : 1;
  if (alpha <= 0.02) return;

  const seed = this.iceWallSeed(v);
  const jit = (i) => this.iceWallHash(i, seed);
  const crack = this.voidglassCrackLevel(hits);

  c.save();
  c.globalAlpha = alpha;
  c.translate(v.x, v.y);

  if (melt) {
    c.fillStyle = rgba("#8fdcff", 0.22 * (1 - meltProg));
    c.beginPath();
    c.ellipse(0, r * 0.42, r * (0.95 + meltProg * 0.65), r * 0.34, 0, 0, TAU);
    c.fill();
    this.drawVoidglassCrumblePieces(v, r, meltProg, alpha, seed);
    c.restore();
    return;
  }

  const lightAng = Math.PI * 1.25;
  const lcx = Math.cos(lightAng);
  const lcy = Math.sin(lightAng);
  const inv = this.scale / this.scaleY;
  const twirl = v._twirlAng || 0;
  c.rotate(twirl);

  const shrink = 1 - crack * 0.04;
  const H = r * (0.82 + jit(99) * 0.18) * inv * shrink;
  const N = 12;
  const fp = [];
  const capH = [];

  for (let i = 0; i < N; i++) {
    const a = (i / N) * TAU + (jit(i + 40) - 0.5) * 0.42;
    const rr = r * shrink * (0.58 + 0.42 * jit(i));
    fp.push({ x: Math.cos(a) * rr, y: Math.sin(a) * rr });
    capH.push(H * (0.86 + 0.68 * jit(i + 20)));
  }

  c.fillStyle = "rgba(4,10,22,0.42)";
  c.beginPath();
  c.ellipse(r * 0.26, r * 0.34, r * 1.12 * shrink, r * 0.58 * shrink, 0, 0, TAU);
  c.fill();

  for (let i = 0; i < N; i++) {
    const p = fp[i];
    const q = fp[(i + 1) % N];
    let nx = q.y - p.y;
    let ny = -(q.x - p.x);
    const nl = Math.hypot(nx, ny) || 1;
    nx /= nl;
    ny /= nl;
    if (ny < -0.04) continue;
    const my = (p.y + q.y) * 0.5;
    c.beginPath();
    c.moveTo(p.x, p.y - capH[i]);
    c.lineTo(q.x, q.y - capH[(i + 1) % N]);
    c.lineTo(q.x, q.y);
    c.lineTo(p.x, p.y);
    c.closePath();
    const g = c.createLinearGradient(0, my - H, 0, my + r * 0.22);
    g.addColorStop(0, rgba("#5a7898", 0.92 - crack * 0.1));
    g.addColorStop(0.45, rgba("#2a3850", 0.95));
    g.addColorStop(1, rgba("#121828", 0.98));
    c.fillStyle = g;
    c.fill();
    const o = nx * lcx + ny * lcy;
    c.fillStyle = o >= 0 ? `rgba(200,240,255,${o * 0.2})` : `rgba(0,0,0,${-o * 0.42})`;
    c.fill();
  }

  const capPath = () => {
    c.beginPath();
    for (let i = 0; i < N; i++) {
      const p = fp[i];
      if (i) c.lineTo(p.x, p.y - capH[i]);
      else c.moveTo(p.x, p.y - capH[i]);
    }
    c.closePath();
  };

  capPath();
  const tg = c.createRadialGradient(-r * 0.36, -r * 0.44 - H, r * 0.08, 0, -H, r * 1.28);
  tg.addColorStop(0, rgba("#e8fbff", 0.88 - crack * 0.18));
  tg.addColorStop(0.38, rgba("#9fd4f0", 0.78 - crack * 0.14));
  tg.addColorStop(0.72, rgba("#4a6888", 0.85));
  tg.addColorStop(1, rgba("#1a2840", 0.92));
  c.fillStyle = tg;
  c.fill();

  for (let i = 0; i < N; i++) {
    const p = fp[i];
    const q = fp[(i + 1) % N];
    const dx = (p.x + q.x) * 0.5;
    const dy = (p.y + q.y) * 0.5;
    const dl = Math.hypot(dx, dy) || 1;
    const o = (dx / dl) * lcx + (dy / dl) * lcy;
    c.beginPath();
    c.moveTo(0, -H * 0.58);
    c.lineTo(p.x, p.y - capH[i]);
    c.lineTo(q.x, q.y - capH[(i + 1) % N]);
    c.closePath();
    c.fillStyle = o >= 0 ? `rgba(240,252,255,${o * 0.18})` : `rgba(4,10,20,${-o * 0.22})`;
    c.fill();
  }

  if (hits > 0) {
    this.voidglassCrackLines(fp, capH, r, seed, hits, crack);
  }

  if (crack > 0.2) {
    c.globalCompositeOperation = "source-atop";
    capPath();
    c.fillStyle = rgba("#1a0804", 0.08 * crack);
    c.fill();
    c.globalCompositeOperation = "source-over";
  }

  capPath();
  c.lineJoin = "round";
  c.lineWidth = 2;
  c.strokeStyle = `rgba(8,16,28,${0.5 + crack * 0.2})`;
  c.stroke();
  c.lineWidth = 1.5;
  c.strokeStyle = rgba("#e8fbff", 0.42 - crack * 0.12);
  c.beginPath();
  let lipOn = false;
  for (let i = 0; i <= N; i++) {
    const p = fp[i % N];
    const a = (i / N) * TAU;
    const toward = Math.cos(a) * lcx + Math.sin(a) * lcy;
    if (toward > 0.08) {
      if (lipOn) c.lineTo(p.x, p.y - capH[i % N]);
      else { c.moveTo(p.x, p.y - capH[i % N]); lipOn = true; }
    } else lipOn = false;
  }
  c.stroke();

  c.restore();
};

Game.prototype.drawVoidglass = function () {
  // arming glacier is depth-sorted via drawIceWallMass; meteor uses the normal projectile draw
};

Game.prototype.updateVoidglassFX = function (dt) {
  for (const v of this.voidglass || []) {
    if (v.ph !== 1) continue;
    if (v._twirlVel) {
      v._twirlAng = (v._twirlAng || 0) + v._twirlVel * dt;
      v._twirlVel *= Math.max(0, 1 - 16 * dt);
      if (Math.abs(v._twirlVel) < 0.08) v._twirlVel = 0;
    }
    if (!v._twirlVel || Math.abs(v._twirlVel) < 1.2) continue;
    v._sparkAcc = (v._sparkAcc || 0) + dt * 2.5;
    while (v._sparkAcc >= 1) {
      v._sparkAcc -= 1;
      if (Math.random() > 0.55) continue;
      const r = v.r || 34;
      const a = rand(0, TAU);
      this.particles.push(new Particle(
        v.x + Math.cos(a) * r * 0.55,
        v.y + Math.sin(a) * r * 0.45 - r * 0.25,
        rand(-18, 18), rand(-28, -4),
        rand(0.15, 0.35),
        Math.random() < 0.5 ? "#ffb060" : "#e8fbff",
        rand(1, 2.2),
        { kind: "spark", grav: 140, drag: 0.93 },
      ));
    }
  }
};
